// Shared "Image Coming Soon" placeholder -- used everywhere a product has
// no Tixaru Front Image / Back Image, instead of a generic stock photo
// (the old /products/tft-display.png fallback). A plain data-URI so it
// drops straight into any <img src> (including onError handlers) without
// needing every call site to switch to conditional JSX rendering.
const SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
  <rect width="400" height="300" fill="#f5f5f0"/>
  <g opacity="0.55">
    <rect x="140" y="95" width="120" height="90" rx="8" fill="none" stroke="#1a5c42" stroke-width="4"/>
    <circle cx="165" cy="120" r="10" fill="#1a5c42"/>
    <polyline points="140,175 175,140 205,160 235,130 260,155 260,185 140,185" fill="#1a5c42"/>
  </g>
  <text x="200" y="228" font-family="Arial, Helvetica, sans-serif" font-size="20" font-weight="600" fill="#1a5c42" text-anchor="middle">Image Coming Soon</text>
</svg>`;

export const IMAGE_COMING_SOON = `data:image/svg+xml,${encodeURIComponent(SVG)}`;
